import { render } from "./Presenze.vue?vue&type=template&id=78237f26&scoped=true"
import script from "./Presenze.vue?vue&type=script&lang=js"
export * from "./Presenze.vue?vue&type=script&lang=js"

import "./Presenze.vue?vue&type=style&index=0&id=78237f26&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_energy-saving_1764367324033741919/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78237f26"]])

export default __exports__